import React from "react";

const Health = () => {
  return <div>Enjoy the silence</div>;
};

export default Health;
